import { yup } from 'utils';

export default yup.object().shape({
  patient_name_kana: yup
    .string()
    .required('ふりがなを入力して下さい')
    .matches(/^[ぁ-んー　]*$/, 'ひらがなで入力して下さい'),
  patient_name: yup.string().required('氏名を入力して下さい'),
  address_1: yup.string().required('住所を入力して下さい'),
  facility_name: yup.string().required('医療機関を選択して下さい'),
});
